<template>
    <div>
        <el-upload
                class="upload-demo"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :http-request="handleUpload"
                :file-list="fileList"
                action="http://server.modijiaoyu.com:9502/api/uploadCert"
                :multiple="false"
                list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
        </el-upload>
    </div>
</template>
<script>
    import store from '@/store'
    export default {
        name: "Upload",
        data() {
            return {
                fileList: [],
                imageUrl: '',
            };
        },
        created(){
        },
        methods: {
            handleUpload(param){
                if ( param.file.type !== 'image/png' &&  param.file.type !== 'image/jpeg') {
                    this.$Message.warning('请上传 jpg/png 格式图片');
                    return false;
                }
                var form = new FormData();
                // 文件对象
                form.append("file", param.file);
                form.append("invoiceId",this.$route.params.invoiceId);
                form.append("type", this.$route.params.type);
                this.$axios.post(store.state.server + '/uploadCert',form
                    , {
                        headers: {
                            'Authorization':'Bearer ' + localStorage.token
                        }
                    }).then((response) => {
                    if (response.data.code == '0000') {
                        this.$message({
                            type: 'success',
                            message: '上传成功'
                        });
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            }
        }
    }
</script>